import React from 'react';
import {
  Button,
  Stack,
  Body,
  Box,
  Divider,
  useWindowProperties,
} from '@qred/components-library';
import { confirmContractAction } from '~/store/actions/additionalSignerActions';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { ApiStatus } from '~/store/types/sharedTypes';
import { RootState } from '~/store';
import useLoanConsentText from '~/hooks/useLoanConsentText';
import useTranslate from '~/hooks/useTranslate';

const LoanAdditionalSignerFooter = () => {
  const {
    additionalSigner: {
      additionalSignerLoanApplicationOffer: { loan_type },
      apiStatus: { postAdditionalSignerLoanApplication },
    },
  } = useSelector((state: RootState) => state);

  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const consentText = useLoanConsentText({ loanType: loan_type });
  const { isMobile } = useWindowProperties();

  const onConfirmLoanClick = () => {
    dispatch(confirmContractAction());
  };

  return (
    <Box>
      <Divider thickness={1} color="neutral.16" />
      <Stack spacing={'md'} align="center" p={isMobile ? 'md' : 'xxl'}>
        <Body size="sm">{consentText}</Body>
        <Button
          fullWidth={isMobile}
          onClick={onConfirmLoanClick}
          size="md"
          isLoading={postAdditionalSignerLoanApplication === ApiStatus.Started}
        >
          {translate('ConfirmTermsCard.ConfirmAgreement')}
        </Button>
      </Stack>
    </Box>
  );
};

export default LoanAdditionalSignerFooter;
